export const coreEn = {
  errors: {
    'intercom-load': 'Failed to load support chat',
  },
  nav: {
    links: {
      admin: {
        brands: 'Brands',
        locations: 'Locations',
        onboarding: 'Onboarding',
        register: '[New] Sales Register',
        registerUsFoods: '[New] US Foods Register',
        subscribe: 'Sales Register',
        subscribeOld: '[Old] Sales Register',
        usFoodsSubscribe: 'US Foods Register',
        usFoodsSubscribeOld: '[Old] US Foods Register',
        users: 'Users',
      },
      marketing: {
        automations: 'Automated',
        flyers: 'Flyers',
        otc: 'One-time',
        overview: 'Overview',
      },
      reports: {
        dashboard: 'Dashboard',
        reports: 'Reports',
      },
      restaurant: {
        careers: 'Jobs',
        coupon: 'Coupons',
        delivery: 'Delivery',
        devices: 'Devices',
        feedback: 'Feedback',
        'gift-cards': 'Gift Cards',
        hours: 'Hours',
        menu: 'Menu',
        orders: 'Orders',
        stations: 'Stations',
      },
      seo: {
        'cuisine-categories': 'Cuisine categories',
        redirects: 'Redirects',
        'seo-info': 'SEO Info',
        'seo-settings': 'SEO Settings',
      },
      staff: {
        jobs: 'Jobs',
        members: 'Members',
        pay: 'Pay',
      },
      tools: {
        acceptances: 'Acceptances',
        'clone-menu': 'Clone Menu',
        'conversion-cards': 'Conversion Cards',
        'delete-location-brand': 'Delete Location/Brand',
        delivery: 'Delivery options',
        dns: 'DNS',
        fees: 'Owner fee',
        'hot-launch': 'VIP Launch',
        'in-store-app-adoption-materials': 'App Adoption Materials',
        onboarding: 'Onboarding',
        'phone-tree': 'Phone Assist',
        'sms-subscriber-import': 'SMS Subscriber Import',
        stations: 'Station Management',
        tips: 'Tips',
        'virtual-card': 'Apple Developer Card',
      },
      website: {
        announcements: 'Announcements',
        customerAnalytics: 'Analytics',
        domains: 'Domain',
        events: 'Events',
        forms: 'Forms',
        integrations: 'Integrations',
        pages: 'Pages',
      },
    },
    options: {
      admin: {
        brands: 'Brands',
        locations: 'Locations',
        onboarding: 'Onboarding',
        register: '[New] Sales Register',
        registerUsFoods: '[New] US Foods Register',
        root: 'Admin',
        subscribe: 'Sales Register',
        subscribeOld: '[Old] Sales Register',
        usFoodsSubscribe: 'US Foods Register',
        usFoodsSubscribeOld: '[Old] US Foods Register',
        users: 'Users',
      },
      billing: {
        account: 'Account',
        'gift-cards': 'Gift Cards',
        invoices: 'Invoices',
        payouts: 'Payouts',
        root: 'Payments',
        subscriptions: 'Subscriptions',
        transactions: 'Transactions',
      },
      'brand-status': 'Brand Status',
      customers: 'Customers',
      home: 'Home',
      marketing: {
        automations: 'Automated',
        coupon: 'Coupons',
        flyers: 'Flyers',
        otc: 'One-time',
        overview: 'Overview',
        root: 'Marketing',
      },
      menu: 'Menu',
      orders: 'Orders',
      reports: 'Reports',
      seo: {
        'cuisine-categories': 'Cuisine categories',
        listings: 'Listings',
        redirects: 'Redirects',
        root: 'SEO',
        'seo-info': 'SEO Info',
        'seo-settings': 'SEO Settings',
      },
      settings: {
        brand: {
          alerts: {
            'form-submissions': 'Form submissions',
            root: 'Alerts',
          },
          details: 'Brand details',
          marketing: {
            root: 'Marketing',
            'sms-marketing': 'SMS marketing',
          },
          marketplaces: {
            doordash: 'DoorDash',
            root: 'Marketplaces',
          },
        },
        location: {
          alerts: {
            'catering-requests': 'Catering requests',
            'form-submissions': 'Form submissions',
            root: 'Alerts',
          },
          details: 'Location details',
          devices: 'Devices',
          fees: 'Fees',
          hours: {
            'activity-log': 'Activity log',
            'online-hours': {
              'edit-day': 'Edit day',
              root: 'Online hours',
            },
            root: 'Hours',
            'special-hours': {
              add: 'Add special hours',
              edit: 'Edit special hours',
              root: 'Special hours',
            },
            'store-hours': {
              'edit-day': 'Edit day',
              root: 'Store hours',
            },
          },
          integrations: 'Integrations',
          notifications: {
            'catering-requests': 'Catering requests',
            'form-submissions': 'Form submissions',
            root: 'Notifications',
          },
          'ordering-options': {
            catering: 'Catering',
            delivery: {
              'add-zone': 'Add delivery zone',
              'edit-zone': 'Edit delivery zone',
              root: 'Delivery',
            },
            root: 'Orders and delivery',
          },
          'prep-time': {
            'add-override': 'Add Override',
            'edit-override': 'Edit Override',
            root: 'Prep time',
          },
          stations: {
            add: 'Add station',
            edit: 'Edit station',
            root: 'Stations',
          },
        },
        root: 'Settings',
      },
      staff: {
        // Are these being used?
        jobs: 'Jobs',
        members: 'Members',
        root: 'Staff',
        timesheets: 'Timesheets',
      },
      tools: {
        acceptances: 'Acceptances',
        'clone-menu': 'Clone Menu',
        'conversion-cards': 'Conversion Cards',
        'delete-location-brand': 'Delete Location/Brand',
        delivery: 'Delivery options',
        dns: 'DNS',
        fees: 'Owner fee',
        'hot-launch': 'VIP Launch',
        'in-store-app-adoption-materials': 'App Adoption Materials',
        onboarding: 'Onboarding',
        'phone-tree': 'Phone Assist',
        root: 'Tools',
        'sms-subscriber-import': 'SMS Subscriber Import',
        stations: 'Station Management',
        tips: 'Tips',
        'virtual-card': 'Apple Developer Card',
      },
      website: {
        announcements: 'Announcements',
        careers: 'Careers',
        customerAnalytics: 'Analytics',
        domains: 'Domain',
        events: 'Events',
        feedback: 'Feedback',
        forms: 'Forms',
        pages: 'Pages',
        root: 'Website',
      },
    },
    toggles: {
      admin: 'Admin',
      'brand-status': 'Brand Status',
      customers: 'Customers',
      home: 'Home',
      marketing: 'Marketing',
      reports: 'Reports',
      restaurant: 'Restaurant',
      seo: 'SEO',
      staff: 'Staff',
      tools: 'Tools',
      website: 'Website',
    },
  },
  pages: {
    admin: {
      brands: {
        description: 'Find the brands you need quickly.',
        title: 'Brands',
      },
      'gbp-oauth': { title: 'Owner Google Account for GBP' },
      locations: {
        description: 'Find the locations you need quickly.',
        title: 'Locations',
      },
      onboarding: { title: 'Onboarding' },
      users: { title: 'Users' },
    },
    auth: {
      'admin-subscribe': { title: 'New Subscription' },
      'direct-register': { title: 'Register' },
      'forgot-password': { title: 'Forgot Password' },
      login: { title: 'Login' },
      'multi-factor-auth': { title: 'Verification Sent' },
      'multi-factor-auth-v2': { title: 'Verification Sent' },
      'multi-factor-auth-verify': { title: 'Verifying' },
      'reset-password': { title: 'Reset Password' },
      subscribe: { title: 'New Subscription' },
    },
    billing: {
      account: {
        title: 'Account',
      },
      description: 'Keep track of your payments to and from Owner.',
      invoices: {
        title: 'Invoices',
      },
      payouts: {
        title: 'Payouts',
      },
      subscriptions: {
        title: 'Subscriptions',
      },
      title: 'Billing',
      transactions: {
        title: 'Transactions',
      },
    },
    'brand-status': {
      overview: {
        description:
          'This page provides a comprehensive overview of the onboarding progress for this brand and its configuration status within our systems.',
        title: 'Brand Status',
      },
    },
    customers: { title: 'Customers' },
    fallback: { title: 'Dashboard' },
    home: { title: 'Home' },
    marketing: {
      automations: {
        description:
          'Email and text campaigns designed and sent on your behalf by Owner.',
        title: 'Automated marketing',
      },
      flyers: {
        description:
          'Our new conversion cards are the best-in-class system to convert delivery app customers into regulars on your own website. Use this page to request an order of 500 cards -- for free. Expect a new shape in the mail and huge results!',
        title: 'Conversion cards: like flyers but 10x more effective!',
      },
      otc: {
        description: 'Create and manage one-time email and text campaigns.',
        title: 'One-time marketing',
      },
      overview: {
        description: 'A summary of email and text campaign performance.',
        title: 'Marketing overview',
      },
    },
    oauth: {
      google: { title: 'Connecting Google...' },
      'google-service': { title: 'Connecting Google...' },
      stripe: { title: 'Connecting Stripe...' },
    },
    onboarding: {
      admin: {
        register: { title: 'Get Started' },
        'register-brands': { title: 'Locations' },
        'register-user': { title: 'Your Information' },
        subscribe: { title: 'Subscribe' },
      },
      register: { title: 'Get Started' },
      'register-brands': { title: 'Locations' },
      'register-code': { title: 'Enter Code' },
      'register-user': { title: 'Your Information' },
      subscribe: { title: 'Subscribe' },
    },
    reports: {
      dashboard: { title: 'Dashboard' },
      reports: { title: 'Reports' },
    },
    'reports-v2': {
      costOfLaborReport: { title: 'Cost of Labor' },
      feesReport: { title: 'Fees' },
      paymentMethodsReport: { title: 'Payment Methods' },
      payoutsDetail: { title: 'Payout Detail' },
      payoutsStatsReport: { title: 'Payout Stats' },
      reports: { title: 'Reports' },
      salesSummaryReport: { title: 'Sales Summary' },
      tipsReport: { title: 'Tips' },
    },
    restaurant: {
      careers: {
        description: 'Manage jobs that are advertised on your website.',
        title: 'Jobs',
      },
      coupons: {
        description:
          'Create and manage coupons. Coupons apply to the total of an order, such as a Military Discount, Birthday Discount, or Student Discount.',
        title: 'Coupons',
      },
      delivery: {
        description:
          'Zones are listed in order of priority. Delivery availability and method will be determined by the first active zone that matches the delivery location.',
        descriptionWithCatering:
          'Zones are listed in order of priority. Delivery availability and method will be determined by the first active zone that matches the delivery location. Catering orders will only be routed to catering zones if any catering zones are configured.',
        title: 'Delivery',
      },
      devices: {
        description: 'Manage settings for your kitchen tablets.',
        title: 'Devices',
      },
      feedback: {
        description:
          'Manage and respond to feedback you receive from your website.',
        title: 'Feedback',
      },
      'gift-cards': {
        description: 'Manage your online gift cards.',
        title: 'Gift Cards',
      },
      hours: { title: 'Hours' },
      menu: {
        description: 'Set up your menu for online and mobile ordering.',
        title: 'Menu',
      },
      orders: {
        description: 'Manage your orders.',
        title: 'Orders',
      },
      stations: {
        title: 'Stations',
      },
    },
    'select-locations': { title: 'Select locations' },
    seo: {
      'cuisine-categories': { title: 'Cuisine categories' },
      listings: { title: 'Listings' },
      redirects: { title: 'Redirects' },
      'seo-info': { title: 'SEO Info' },
      'seo-settings': { title: 'SEO Settings' },
    },
    settings: { title: 'Settings' },
    'settings-brand': {
      title: 'Brand Settings',
    },
    'staff-jobs': {
      description: 'Manage job postings for your restaurant.',
      title: 'Jobs',
    },
    'staff-members': {
      description: 'Manage your staff members.',
      title: 'Staff',
    },
    'staff-pay': {
      description:
        'Review staff time sheets, to view summaries for running payroll use this report.',
      title: 'Pay',
    },
    'staff-timesheets': {
      description:
        'Review staff time sheets, to view summaries for running payroll use this report.',
      title: 'Timesheets',
    },
    tools: {
      acceptances: {
        title: 'Legal Acceptances',
      },
      'clone-menu': {
        description:
          'Clone menus from one location to another. Only eligible locations are enabled as target locations. Certain locations are disabled due to their POS integration.',
        title: 'Clone Menu',
      },
      'conversion-cards': {
        title: 'Conversion Cards',
      },
      'delete-location-brand': {
        description: 'Delete a restaurant location or brand permanently.',
        title: 'Delete Location/Brand',
      },
      delivery: {
        description:
          'Manage delivery transporation requirements for your locations.',
        title: 'Delivery options',
      },
      dns: {
        description: 'DNS tools',
        title: 'DNS',
      },
      'hot-launch': {
        description: 'Schedule a new VIP Launch campaign.',
        title: 'VIP Launch',
      },
      'in-store-app-adoption-materials': {
        description:
          'Request app adoption materials (posters and table tents), and then generate and download QR codes for creating the designs.',
        title: 'App Adoption Materials',
      },
      onboarding: {
        description: 'Manage onboarding actions.',
        title: 'Onboarding',
      },
      'phone-tree': {
        description:
          'Automatically direct callers to order online or route calls directly to the restaurant.',
        title: 'Setup phone assist',
      },
      'phone-tree-location-selection': {
        description: 'Select a location to setup phone assist for.',
        title: 'Phone assist',
      },
      'sms-subscriber-import': {
        description:
          'Enable SMS subscriptions for customers who previously opted in to text marketing outside of the Owner system.',
        title: 'SMS Subscriber Import',
      },
      stations: {
        description: 'Assign, unassign, and swap devices between stations',
        title: 'Station Device Management',
      },
      tips: {
        description:
          'Configure tip options for pickup, delivery, and in-store orders.',
        title: 'Tips',
      },
      'virtual-card': {
        description:
          'Manage the virtual card for Apple Developer Account renewal payments.',
        title: 'Apple Developer Card',
      },
    },
    website: {
      analytics: {
        description: 'Update analytics integration settings for your website.',
        title: 'Analytics',
      },
      announcements: {
        description: 'Add announcement banners to your website.',
        title: 'Announcements',
      },
      domains: {
        description: 'Manage and verify your website domain.',
        title: 'Domain',
      },
      events: {
        description: 'Manage events on your website.',
        title: 'Events',
      },
      forms: {
        description:
          'Add and manage forms that you can insert into website pages.',
        title: 'Forms',
      },
      integrations: { title: 'Integrations' },
      pages: {
        description: 'Manage pages in your website.',
        title: 'Pages',
      },
    },
  },
}
